import { addDays, format, isAfter, isWithinInterval, parse } from "date-fns";

import { ExpiringIcon } from "@/components/pieces/icons/svg/ExpiringIcon";
import { cn } from "@/lib/utils";

export function ExpiresOnCell({ date }: { date?: string | null }) {
  if (!date) {
    return <div className="text-gray-500">No expiration</div>;
  }

  const expiresOn = parse(date, "yyyy-MM-dd", new Date());
  const isExpiringSoon = isWithinInterval(expiresOn, {
    start: new Date(),
    end: addDays(new Date(), 30),
  });
  const isExpired = isAfter(new Date(), expiresOn);
  return (
    <div
      className={cn(
        "flex items-center gap-1",
        isExpired && "text-red-700",
        isExpiringSoon && "text-yellow-700",
      )}
    >
      {(isExpired || isExpiringSoon) && <ExpiringIcon />}
      {format(expiresOn, "MMM d, yyyy")}
    </div>
  );
}
